import React, { useMemo } from 'react'
import { Modal, Table, Tag, Tooltip } from 'antd'
import dayjs from 'dayjs'

const statusMap = {
  SUCCESS: { color: 'green', label: 'Thành công' },
  FAIL: { color: 'red', label: 'Thất bại' },
  PENDING: { color: 'orange', label: 'Đang gửi' },
}

export default function EmailHistoryModal({
  open,
  onCancel,
  data = [],
  loading = false,
}) {
  const renderEmailList = (val) => {
    if (!val || val.length === 0) return '-'

    const text = Array.isArray(val) ? val.join(', ') : val

    return (
      <Tooltip title={text}>
        <span
          style={{
            display: 'inline-block',
            maxWidth: 250,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </span>
      </Tooltip>
    )
  }

  const statusMap = {
    3: { color: 'green', label: 'Gửi email thành công' },
    2: { color: 'red', label: 'Gửi email thất bại' },
    4: { color: 'processing', label: 'Đang gửi cho khách hàng' },
  }

  const statusTypeEmail = {
    1: { color: 'green', label: 'Đã mở xem' },
    null: { color: 'processing', label: 'Chưa mở' },
  }

  const columns = useMemo(
    () => [
      {
        title: 'Thời gian',
        dataIndex: 'createdAt',
        width: 180,
        render: (val) => (
          <span style={{ color: '#666', fontSize: 12 }}>
            {dayjs(val).format('DD/MM/YYYY HH:mm:ss')}
          </span>
        ),
      },
      {
        title: 'Người nhận',
        ellipsis: true,
        width: 300,
        render: (item) => {
          const to = item?.toEmail
          const cc = item?.ccEmail
          const bcc = item?.bccEmail

          const format = (val) => {
            if (!val || val.length === 0) return null
            return Array.isArray(val) ? val.join(', ') : val
          }

          const toText = format(to)
          const ccText = format(cc)
          const bccText = format(bcc)

          const fullText = [toText, ccText, bccText].filter(Boolean).join(' | ')

          if (!fullText) return '-'

          return (
            <Tooltip
              title={
                <div>
                  {toText && (
                    <div>
                      <b>To:</b> {toText}
                    </div>
                  )}
                  {ccText && (
                    <div>
                      <b>CC:</b> {ccText}
                    </div>
                  )}
                  {bccText && (
                    <div>
                      <b>BCC:</b> {bccText}
                    </div>
                  )}
                </div>
              }
            >
              <div style={{ lineHeight: '18px' }}>
                {toText && (
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 300,
                    }}
                  >
                    <b>To:</b> {toText}
                  </div>
                )}
                {ccText && (
                  <div style={{ color: '#888', fontSize: 12 }}>
                    CC: {ccText}
                  </div>
                )}
                {bccText && (
                  <div style={{ color: '#bbb', fontSize: 12 }}>
                    BCC: {bccText}
                  </div>
                )}
              </div>
            </Tooltip>
          )
        },
      },
      {
        title: 'Tiêu đề',
        dataIndex: 'subject',
        ellipsis: true,
        render: (val) => <Tooltip>{val}</Tooltip>,
      },
      {
        title: 'Trạng thái',
        dataIndex: 'isSent',
        width: 200,
        render: (isSent) => {
          const item = statusMap[Number(isSent)] || {
            color: 'default',
            label: 'Không xác định',
          }

          return (
            <Tag
              color={item.color}
              style={{
                borderRadius: 8,
                padding: '2px 10px',
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              {item.label}
            </Tag>
          )
        },
      },
      {
        title: 'Trạng thái khách hàng nhận email',
        dataIndex: 'customerCheck',
        width: 200,
        render: (customerCheck) => {
          const item = statusTypeEmail[Number(customerCheck)] || {
            color: 'default',
            label: 'Chưa xem',
          }

          return (
            <Tag
              color={item.color}
              style={{
                borderRadius: 8,
                padding: '2px 10px',
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              {item.label}
            </Tag>
          )
        },
      },
    ],
    [],
  )

  const filteredData = useMemo(() => {
    return data.filter((item, index) => {
      // Chỉ check record đang gửi
      if (Number(item.isSent) !== 4) return true

      // Tìm phía sau có gửi thành công cùng email không
      const hasSuccessAfter = data
        .slice(index + 1)
        .some(
          (nextItem) =>
            Number(nextItem.isSent) === 3 && nextItem.toEmail === item.toEmail,
        )

      // Nếu có thì ẩn
      return !hasSuccessAfter
    })
  }, [data])

  return (
    <Modal
      title={
        <span style={{ fontWeight: 600, fontSize: 18 }}>Lịch sử gửi email</span>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width="min(1200px, 95vw)"
      centered
      styles={{
        body: {
          padding: 12,
        },
      }}
    >
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={filteredData}
        loading={{
          spinning: loading,
          tip: 'Đang tải lịch sử...',
        }}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000, y: 500 }}
        bordered
        size="middle"
      />
    </Modal>
  )
}
